import * as React from "react";

const ArrowLeftIcon = (props: any) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.44518 12.0624L11.7683 19.3855C11.9789 19.5961 12.0829 19.8426 12.0803 20.125C12.0775 20.4074 11.9663 20.6585 11.7467 20.8783C11.5269 21.0835 11.278 21.1898 11.0001 21.1971C10.7222 21.2044 10.4733 21.0982 10.2535 20.8783L1.27149 11.8963C1.1388 11.7636 1.0453 11.6237 0.990992 11.4766C0.93645 11.3295 0.90918 11.1706 0.90918 10.9999C0.90918 10.8292 0.93645 10.6703 0.990992 10.5232C1.0453 10.3761 1.1388 10.2362 1.27149 10.1035L10.2535 1.1215C10.4497 0.92529 10.6927 0.824943 10.9824 0.820456C11.2721 0.81597 11.5269 0.916318 11.7467 1.1215C11.9663 1.34132 12.0761 1.59372 12.0761 1.87871C12.0761 2.16393 11.9663 2.41645 11.7467 2.63627L4.44518 9.93741H20.5626C20.8641 9.93741 21.1165 10.0392 21.3198 10.2427C21.5233 10.446 21.6251 10.6984 21.6251 10.9999C21.6251 11.3014 21.5233 11.5538 21.3198 11.7571C21.1165 11.9607 20.8641 12.0624 20.5626 12.0624H4.44518Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowLeftIcon;
